import { apiGet, apiPost } from './api';

export interface ShopCategory {
  id: number;
  title: string;
  ordem?: number;
  active?: number;
}

export interface ShopProductOption {
  id: number;
  itemid?: number;
  itemidopt?: number;
  itemopt?: number;
  durationid?: number;
  title?: string;
  price?: number;
  active?: number;
}

export interface ShopProduct {
  id: number;
  categoryid?: number;
  itemid: number;
  itemopt?: number;
  durationid?: number;
  title: string;
  description?: string;
  price: number;
  accountbind?: number;
  itemcount?: number;
  active?: number;
  options?: ShopProductOption[];
  image?: string | null;
}

/**
 * Resolve a imagem de produto: o cadastro guarda só o nome do arquivo e o
 * nginx do host serve a pasta (SHOP_IMG_DIR) em /shop-img/. URLs completas
 * passam direto (compat com cadastros antigos).
 */
export const shopImg = (image?: string | null): string => {
  if (!image) return '';
  if (/^https?:/.test(image) || image.startsWith('/')) return image;
  return `/shop-img/${image}`;
};

/** GET /Shop/available — loja tem categoria/produto? (esconde o menu se não) */
export const getShopAvailable = () => apiGet<{ available: boolean }>('/Shop/available');

/** GET /Shop/categories — categorias da loja */
export const getShopCategories = () => apiGet<ShopCategory[]>('/Shop/categories');

/** GET /Shop/products?categoryId= — produtos de uma categoria */
export const getShopProducts = (categoryId: number) =>
  apiGet<ShopProduct[]>('/Shop/products', { categoryId });

/** POST /Shop/buy — compra (deduz cash) */
export const buyProduct = (body: { itemid: number; optionid: number; itemqty: number }) =>
  apiPost<{ status: string; message: string }>('/Shop/buy', body);

/** GET /Shop/getHistory — histórico de compras */
export const getShopHistory = () => apiGet<any[]>('/Shop/getHistory');
